webpackJsonp(["pages.projects.commit.pipelines"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/**
 * Renders each stage of the pipeline mini graph.
 *
 * Given the provided endpoint will make a request to
 * fetch the dropdown data when the stage is clicked.
 *
 * Request is made inside this component to make it reusable between:
 * 1. Pipelines main table
 * 2. Pipelines table in commit and Merge request views
 * 3. Merge request widget
 * 4. Commit widget
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__["a" /* default */]
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__["a" /* default */]
  },

  props: {
    stage: {
      type: Object,
      required: true
    },

    updateDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      isLoading: false,
      dropdownContent: ''
    };
  },


  computed: {
    dropdownClass: function dropdownClass() {
      return this.dropdownContent.length > 0 ? 'js-builds-dropdown-container' : 'js-builds-dropdown-loading';
    },
    triggerButtonClass: function triggerButtonClass() {
      return 'ci-status-icon-' + this.stage.status.group;
    },
    borderlessIcon: function borderlessIcon() {
      return this.stage.status.icon + '_borderless';
    }
  },

  watch: {
    updateDropdown: function updateDropdown() {
      if (this.updateDropdown && this.isDropdownOpen() && !this.isLoading) {
        this.fetchJobs();
      }
    }
  },

  updated: function updated() {
    if (this.dropdownContent.length > 0) {
      this.stopDropdownClickPropagation();
    }
  },


  methods: {
    onClickStage: function onClickStage() {
      if (!this.isDropdownOpen()) {
        this.isLoading = true;
        this.fetchJobs();
      }
    },
    fetchJobs: function fetchJobs() {
      var _this = this;

      this.$http.get(this.stage.dropdown_path).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.dropdownContent = data.html;
        _this.isLoading = false;
      }).catch(function () {
        _this.closeDropdown();
        _this.isLoading = false;

        var flash = new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Something went wrong on our end.');
        return flash;
      });
    },


    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen()) {
        $(this.$refs.dropdown).dropdown('toggle');
      }
    },
    isDropdownOpen: function isDropdownOpen() {
      return this.$el.classList.contains('open');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../views/shared/icons/_icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3.876-1.008a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 4 9H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 12 7h3a1 1 0 0 1 0 2h-3a1.01 1.01 0 0 1-.124-.008z\"/></svg>\n\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_timer.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><g fill=\"#8F8F8F\" fill-rule=\"evenodd\"><path d=\"M29.513 10.134A15.922 15.922 0 0 0 23 7.28V6h2.993C26.55 6 27 5.552 27 5V2a1 1 0 0 0-1.007-1H14.007C13.45 1 13 1.448 13 2v3a1 1 0 0 0 1.007 1H17v1.28C9.597 8.686 4 15.19 4 23c0 8.837 7.163 16 16 16s16-7.163 16-16c0-3.461-1.099-6.665-2.967-9.283l1.327-1.58a2.498 2.498 0 0 0-.303-3.53 2.499 2.499 0 0 0-3.528.315l-1.016 1.212zM20 34c6.075 0 11-4.925 11-11s-4.925-11-11-11S9 16.925 9 23s4.925 11 11 11z\"/><path d=\"M19 21h-4.002c-.552 0-.998.452-.998 1.01v1.98c0 .567.447 1.01.998 1.01h7.004c.274 0 .521-.111.701-.291a.979.979 0 0 0 .297-.704v-8.01c0-.54-.452-.995-1.01-.995h-1.98a.997.997 0 0 0-1.01.995V21z\"/></g></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./commit/pipelines/pipelines_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./pipelines/services/pipelines_service.js
var pipelines_service = __webpack_require__("./pipelines/services/pipelines_service.js");

// EXTERNAL MODULE: ./pipelines/stores/pipelines_store.js
var pipelines_store = __webpack_require__("./pipelines/stores/pipelines_store.js");

// EXTERNAL MODULE: ./pipelines/mixins/pipelines.js + 27 modules
var pipelines = __webpack_require__("./pipelines/mixins/pipelines.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./commit/pipelines/pipelines_table.vue





/* harmony default export */ var pipelines_table = ({
  mixins: [pipelines["a" /* default */]],
  props: {
    endpoint: {
      type: String,
      required: true
    },
    helpPagePath: {
      type: String,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    errorStateSvgPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: false,
      default: 'child'
    }
  },

  data: function data() {
    var store = new pipelines_store["a" /* default */]();

    return {
      store: store,
      state: store.state
    };
  },


  computed: {
    shouldRenderTable: function shouldRenderTable() {
      return !this.isLoading && this.state.pipelines.length > 0 && !this.hasError;
    },
    shouldRenderErrorState: function shouldRenderErrorState() {
      return this.hasError && !this.isLoading;
    }
  },
  created: function created() {
    this.service = new pipelines_service["a" /* default */](this.endpoint);
  },

  methods: {
    successCallback: function successCallback(resp) {
      var _this = this;

      return resp.json().then(function (response) {
        // depending of the endpoint the response can either bring a `pipelines` key or not.
        var pipelines = response.pipelines || response;
        _this.setCommonData(pipelines);

        var updatePipelinesEvent = new CustomEvent('update-pipelines-count', {
          detail: {
            pipelines: response
          }
        });

        // notifiy to update the count in tabs
        if (_this.$el.parentElement) {
          _this.$el.parentElement.dispatchEvent(updatePipelinesEvent);
        }
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b04960","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./commit/pipelines/pipelines_table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-list pipelines"},[(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-20",attrs:{"label":_vm.s__('Pipelines|Loading Pipelines'),"size":"3"}}):(_vm.shouldRenderErrorState)?_c('svg-blank-state',{attrs:{"svg-path":_vm.errorStateSvgPath,"message":_vm.s__("Pipelines|There was an error fetching the pipelines.\n    Try again in a few moments or contact your support team.")}}):(_vm.shouldRenderTable)?_c('div',{staticClass:"table-holder"},[_c('pipelines-table-component',{attrs:{"pipelines":_vm.state.pipelines,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./commit/pipelines/pipelines_table.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_pipelines_table = (Component.exports);

// CONCATENATED MODULE: ./commit/pipelines/pipelines_bundle.js



/**
 * Used in:
 *  - Commit details View > Pipelines Tab > Pipelines Table.
 *  - Merge Request details View > Pipelines Tab > Pipelines Table.
 *  - New Merge Request View > Pipelines Tab > Pipelines Table.
 */

var CommitPipelinesTable = vue_esm["a" /* default */].extend(pipelines_pipelines_table);

// export for use in merge_request_tabs.js (TODO: remove this hack when we understand how to load
// vue.js in merge_request_tabs.js)
window.gl = window.gl || {};
window.gl.CommitPipelinesTable = CommitPipelinesTable;

/* harmony default export */ var pipelines_bundle = __webpack_exports__["a"] = (function () {
  var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');

  if (pipelineTableViewEl) {
    // Update MR and Commits tabs
    pipelineTableViewEl.addEventListener('update-pipelines-count', function (event) {
      if (event.detail.pipelines && event.detail.pipelines.count && event.detail.pipelines.count.all) {
        var badge = document.querySelector('.js-pipelines-mr-count');

        badge.textContent = event.detail.pipelines.count.all;
      }
    });

    if (pipelineTableViewEl.dataset.disableInitialization === undefined) {
      var table = new CommitPipelinesTable({
        propsData: {
          endpoint: pipelineTableViewEl.dataset.endpoint,
          helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
          emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
          errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
          autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
        }
      }).$mount();
      pipelineTableViewEl.appendChild(table.$el);
    }
  }
});

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./mini_pipeline_graph_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */



/**
 * In each pipelines table we have a mini pipeline graph for each pipeline.
 *
 * When we click in a pipeline stage, we need to make an API call to get the
 * builds list to render in a dropdown.
 *
 * The container should be the table element.
 *
 * The stage icon clicked needs to have the following HTML structure:
 * <div class="dropdown">
 *   <button class="dropdown js-builds-dropdown-button" data-toggle="dropdown"></button>
 *   <div class="js-builds-dropdown-container dropdown-menu"></div>
 * </div>
 */

var MiniPipelineGraph = function () {
  function MiniPipelineGraph() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MiniPipelineGraph);

    this.container = opts.container || '';
    this.dropdownListSelector = '.js-builds-dropdown-container';
    this.getBuildsList = this.getBuildsList.bind(this);
  }

  /**
   * Adds the event listener when the dropdown is opened.
   * All dropdown events are fired at the .dropdown-menu's parent element.
   */


  _createClass(MiniPipelineGraph, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).off('shown.bs.dropdown', this.container).on('shown.bs.dropdown', this.container, this.getBuildsList);
    }

    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */

  }, {
    key: 'stopDropdownClickPropagation',
    value: function stopDropdownClickPropagation() {
      $(document).on('click', this.container + ' .js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item', function (e) {
        e.stopPropagation();
      });
    }

    /**
     * For the clicked stage, renders the given data in the dropdown list.
     *
     * @param  {HTMLElement} stageContainer
     * @param  {Object} data
     */

  }, {
    key: 'renderBuildsList',
    value: function renderBuildsList(stageContainer, data) {
      var dropdownContainer = stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-list');

      dropdownContainer.innerHTML = data;
    }

    /**
     * For the clicked stage, gets the list of builds.
     *
     * All dropdown events have a relatedTarget property,
     * whose value is the toggling anchor element.
     *
     * @param  {Object} e bootstrap dropdown event
     * @return {Promise}
     */

  }, {
    key: 'getBuildsList',
    value: function getBuildsList(e) {
      var _this = this;

      var button = e.relatedTarget;
      var endpoint = button.dataset.stageEndpoint;

      this.renderBuildsList(button, '');
      this.toggleLoading(button);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(endpoint).then(function (_ref) {
        var data = _ref.data;

        _this.toggleLoading(button);
        _this.renderBuildsList(button, data.html);
        _this.stopDropdownClickPropagation();
      }).catch(function () {
        _this.toggleLoading(button);
        if ($(button).parent().hasClass('open')) {
          $(button).dropdown('toggle');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */])('An error occurred while fetching the builds.', 'alert');
      });
    }

    /**
     * Toggles the visibility of the loading icon.
     *
     * @param  {HTMLElement} stageContainer
     * @return {type}
     */

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(stageContainer) {
      stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-loading').classList.toggle('hidden');
    }
  }]);

  return MiniPipelineGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (MiniPipelineGraph);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/projects/commit/pipelines/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mini_pipeline_graph_dropdown__ = __webpack_require__("./mini_pipeline_graph_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commit_pipelines_pipelines_bundle__ = __webpack_require__("./commit/pipelines/pipelines_bundle.js");



document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__mini_pipeline_graph_dropdown__["a" /* default */]({
    container: '.js-commit-pipeline-graph'
  }).bindEvents();
  $('.commit-info.branches').load(document.querySelector('.js-commit-box').dataset.commitPath);
  Object(__WEBPACK_IMPORTED_MODULE_1__commit_pipelines_pipelines_bundle__["a" /* default */])();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue
var stage = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65860e01","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",class:_vm.triggerButtonClass,attrs:{"title":_vm.stage.title,"data-placement":"top","data-toggle":"dropdown","type":"button","id":"stageDropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.onClickStage}},[_c('span',{attrs:{"aria-hidden":"true","aria-label":_vm.stage.title}},[_c('icon',{attrs:{"name":_vm.borderlessIcon}})],1),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",attrs:{"aria-labelledby":"stageDropdown"}},[_c('li',{staticClass:"js-builds-dropdown-list scrollable-menu",class:_vm.dropdownClass},[(_vm.isLoading)?_c('loading-icon'):_c('ul',{domProps:{"innerHTML":_vm._s(_vm.dropdownContent)}})],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/stage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./pipelines/mixins/pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue

/* harmony default export */ var empty_state = ({
  name: 'PipelinesEmptyState',
  props: {
    helpPagePath: {
      type: String,
      required: true
    },
    emptyStateSvgPath: {
      type: String,
      required: true
    },
    canSetCi: {
      type: Boolean,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3569de","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state js-empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content svg-250"},[_c('img',{attrs:{"src":_vm.emptyStateSvgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"text-content"},[(_vm.canSetCi)?[_c('h4',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.s__('Pipelines|Build with confidence'))+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.s__("Pipelines|Continous Integration can help\n              catch bugs by running your tests automatically,\n              while Continuous Deployment can help you deliver\n              code to your product environment."))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary js-get-started-pipelines",attrs:{"href":_vm.helpPagePath}},[_vm._v("\n            "+_vm._s(_vm.s__('Pipelines|Get started with Pipelines'))+"\n          ")])])]:_c('p',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.s__('Pipelines|This project is not currently set up to run pipelines.'))+"\n      ")])],2)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/empty_state.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  empty_state,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_empty_state = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/blank_state.vue

/* harmony default export */ var blank_state = ({
  name: 'PipelinesSvgState',
  props: {
    svgPath: {
      type: String,
      required: true
    },

    message: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190f43c7","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/blank_state.vue
var blank_state_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content"},[_c('img',{attrs:{"src":_vm.svgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_c('div',{staticClass:"text-content"},[_c('h4',[_vm._v(_vm._s(_vm.message))])])])])}
var blank_state_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/blank_state.vue
/* script */


/* template */

/* template functional */
var blank_state___vue_template_functional__ = false
/* styles */
var blank_state___vue_styles__ = null
/* scopeId */
var blank_state___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blank_state___vue_module_identifier__ = null

var blank_state_Component = Object(component_normalizer["a" /* default */])(
  blank_state,
  blank_state_render,
  blank_state_staticRenderFns,
  blank_state___vue_template_functional__,
  blank_state___vue_styles__,
  blank_state___vue_scopeId__,
  blank_state___vue_module_identifier__
)

/* harmony default export */ var components_blank_state = (blank_state_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/modal.vue + 2 modules
var modal = __webpack_require__("./vue_shared/components/modal.vue");

// EXTERNAL MODULE: ./pipelines/event_hub.js
var event_hub = __webpack_require__("./pipelines/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue

/* eslint-disable no-alert */






/* harmony default export */ var async_button = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    endpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: true
    },
    pipelineId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    buttonClass: function buttonClass() {
      return 'btn ' + this.cssClass;
    }
  },
  created: function created() {
    // We're using eventHub to listen to the modal here instead of
    // using props because it would would make the parent components
    // much more complex to keep track of the loading state of each button
    event_hub["a" /* default */].$on('postAction', this.setLoading);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('postAction', this.setLoading);
  },

  methods: {
    onClick: function onClick() {
      event_hub["a" /* default */].$emit('openConfirmationModal', {
        pipelineId: this.pipelineId,
        endpoint: this.endpoint,
        type: this.type
      });
    },
    setLoading: function setLoading(endpoint) {
      if (endpoint === this.endpoint) {
        this.isLoading = true;
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a875a2","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
var async_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.buttonClass,attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title,"data-container":"body","data-placement":"top","disabled":_vm.isLoading},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1)}
var async_button_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/async_button.vue
/* script */


/* template */

/* template functional */
var async_button___vue_template_functional__ = false
/* styles */
var async_button___vue_styles__ = null
/* scopeId */
var async_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var async_button___vue_module_identifier__ = null

var async_button_Component = Object(component_normalizer["a" /* default */])(
  async_button,
  async_button_render,
  async_button_staticRenderFns,
  async_button___vue_template_functional__,
  async_button___vue_styles__,
  async_button___vue_scopeId__,
  async_button___vue_module_identifier__
)

/* harmony default export */ var components_async_button = (async_button_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue






/* harmony default export */ var pipelines_actions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    onClickAction: function onClickAction(endpoint) {
      this.isLoading = true;

      event_hub["a" /* default */].$emit('postAction', endpoint);
    },
    isActionDisabled: function isActionDisabled(action) {
      if (action.playable === undefined) {
        return false;
      }

      return !action.playable;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4131da4d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
var pipelines_actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",attrs:{"type":"button","title":"Manual job","data-toggle":"dropdown","data-placement":"top","aria-label":"Manual job","disabled":_vm.isLoading}},[_c('icon',{staticClass:"icon-play",attrs:{"name":"play"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.actions),function(action,i){return _c('li',{key:i},[_c('button',{staticClass:"js-pipeline-action-link no-btn btn",class:{ disabled: _vm.isActionDisabled(action) },attrs:{"type":"button","disabled":_vm.isActionDisabled(action)},on:{"click":function($event){_vm.onClickAction(action.path)}}},[_vm._v("\n        "+_vm._s(action.name)+"\n      ")])])}))])}
var pipelines_actions_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_actions.vue
/* script */


/* template */

/* template functional */
var pipelines_actions___vue_template_functional__ = false
/* styles */
var pipelines_actions___vue_styles__ = null
/* scopeId */
var pipelines_actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_actions___vue_module_identifier__ = null

var pipelines_actions_Component = Object(component_normalizer["a" /* default */])(
  pipelines_actions,
  pipelines_actions_render,
  pipelines_actions_staticRenderFns,
  pipelines_actions___vue_template_functional__,
  pipelines_actions___vue_styles__,
  pipelines_actions___vue_scopeId__,
  pipelines_actions___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_actions = (pipelines_actions_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue




/* harmony default export */ var pipelines_artifacts = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    artifacts: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8577a5a6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue
var pipelines_artifacts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-toggle btn btn-default build-artifacts js-pipeline-dropdown-download",attrs:{"title":"Artifacts","data-placement":"top","data-toggle":"dropdown","aria-label":"Artifacts"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.artifacts),function(artifact,i){return _c('li',{key:i},[_c('a',{attrs:{"rel":"nofollow","download":"","href":artifact.path}},[_vm._v("\n        Download "+_vm._s(artifact.name)+" artifacts\n      ")])])}))])}
var pipelines_artifacts_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_artifacts.vue
/* script */


/* template */

/* template functional */
var pipelines_artifacts___vue_template_functional__ = false
/* styles */
var pipelines_artifacts___vue_styles__ = null
/* scopeId */
var pipelines_artifacts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_artifacts___vue_module_identifier__ = null

var pipelines_artifacts_Component = Object(component_normalizer["a" /* default */])(
  pipelines_artifacts,
  pipelines_artifacts_render,
  pipelines_artifacts_staticRenderFns,
  pipelines_artifacts___vue_template_functional__,
  pipelines_artifacts___vue_styles__,
  pipelines_artifacts___vue_scopeId__,
  pipelines_artifacts___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_artifacts = (pipelines_artifacts_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/popover.js
var popover = __webpack_require__("./vue_shared/directives/popover.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue





/* harmony default export */ var pipeline_url = ({
  components: {
    userAvatarLink: user_avatar_link["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */],
    popover: popover["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    }
  },
  computed: {
    user: function user() {
      return this.pipeline.user;
    },
    popoverOptions: function popoverOptions() {
      return {
        html: true,
        trigger: 'focus',
        placement: 'top',
        title: '<div class="autodevops-title">\n          This pipeline makes use of a predefined CI/CD configuration enabled by <b>Auto DevOps.</b>\n        </div>',
        content: '<a\n          class="autodevops-link"\n          href="' + this.autoDevopsHelpPath + '"\n          target="_blank"\n          rel="noopener noreferrer nofollow">\n          Learn more about Auto DevOps\n        </a>'
      };
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cea8c848","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
var pipeline_url_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 hidden-xs hidden-sm pipeline-tags"},[_c('a',{staticClass:"js-pipeline-url-link",attrs:{"href":_vm.pipeline.path}},[_c('span',{staticClass:"pipeline-id"},[_vm._v("#"+_vm._s(_vm.pipeline.id))])]),_vm._v(" "),_c('span',[_vm._v("by")]),_vm._v(" "),(_vm.user)?_c('user-avatar-link',{staticClass:"js-pipeline-url-user",attrs:{"link-href":_vm.pipeline.user.path,"img-src":_vm.pipeline.user.avatar_url,"tooltip-text":_vm.pipeline.user.name}}):_vm._e(),_vm._v(" "),(!_vm.user)?_c('span',{staticClass:"js-pipeline-url-api api"},[_vm._v("\n    API\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-container"},[(_vm.pipeline.flags.latest)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-latest label label-success",attrs:{"title":"Latest pipeline for this branch"}},[_vm._v("\n      latest\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.yaml_errors)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-yaml label label-danger",attrs:{"title":_vm.pipeline.yaml_errors}},[_vm._v("\n      yaml invalid\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.failure_reason)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-failure label label-danger",attrs:{"title":_vm.pipeline.failure_reason}},[_vm._v("\n      error\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.auto_devops)?_c('a',{directives:[{name:"popover",rawName:"v-popover",value:(_vm.popoverOptions),expression:"popoverOptions"}],staticClass:"js-pipeline-url-autodevops label label-info autodevops-badge",attrs:{"tabindex":"0","role":"button"}},[_vm._v("\n      Auto DevOps\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.stuck)?_c('span',{staticClass:"js-pipeline-url-stuck label label-warning"},[_vm._v("\n      stuck\n    ")]):_vm._e()])],1)}
var pipeline_url_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipeline_url.vue
/* script */


/* template */

/* template functional */
var pipeline_url___vue_template_functional__ = false
/* styles */
var pipeline_url___vue_styles__ = null
/* scopeId */
var pipeline_url___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipeline_url___vue_module_identifier__ = null

var pipeline_url_Component = Object(component_normalizer["a" /* default */])(
  pipeline_url,
  pipeline_url_render,
  pipeline_url_staticRenderFns,
  pipeline_url___vue_template_functional__,
  pipeline_url___vue_styles__,
  pipeline_url___vue_scopeId__,
  pipeline_url___vue_module_identifier__
)

/* harmony default export */ var components_pipeline_url = (pipeline_url_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_timer.svg
var _icon_timer = __webpack_require__("../../views/shared/icons/_icon_timer.svg");
var _icon_timer_default = /*#__PURE__*/__webpack_require__.n(_icon_timer);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue






/* harmony default export */ var time_ago = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    finishedTime: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      iconTimerSvg: _icon_timer_default.a
    };
  },

  computed: {
    hasDuration: function hasDuration() {
      return this.duration > 0;
    },
    hasFinishedTime: function hasFinishedTime() {
      return this.finishedTime !== '';
    },
    durationFormated: function durationFormated() {
      var date = new Date(this.duration * 1000);

      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      // left pad
      if (hh < 10) {
        hh = '0' + hh;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }

      return hh + ':' + mm + ':' + ss;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369bf334","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
var time_ago_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 pipelines-time-ago"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n    持续时间\n  ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.hasDuration)?_c('p',{staticClass:"duration"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconTimerSvg)}}),_vm._v("\n      "+_vm._s(_vm.durationFormated)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasFinishedTime)?_c('p',{staticClass:"finished-at hidden-xs hidden-sm"},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"data-placement":"top","data-container":"body","title":_vm.tooltipTitle(_vm.finishedTime)}},[_vm._v("\n        "+_vm._s(_vm.timeFormated(_vm.finishedTime))+"\n      ")])]):_vm._e()])])}
var time_ago_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/time_ago.vue
/* script */


/* template */

/* template functional */
var time_ago___vue_template_functional__ = false
/* styles */
var time_ago___vue_styles__ = null
/* scopeId */
var time_ago___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var time_ago___vue_module_identifier__ = null

var time_ago_Component = Object(component_normalizer["a" /* default */])(
  time_ago,
  time_ago_render,
  time_ago_staticRenderFns,
  time_ago___vue_template_functional__,
  time_ago___vue_styles__,
  time_ago___vue_scopeId__,
  time_ago___vue_module_identifier__
)

/* harmony default export */ var components_time_ago = (time_ago_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/commit.vue + 2 modules
var commit = __webpack_require__("./vue_shared/components/commit.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue

/* eslint-disable no-param-reassign */









/**
 * Pipeline table row.
 *
 * Given the received object renders a table row in the pipelines' table.
 */
/* harmony default export */ var pipelines_table_row = ({
  components: {
    asyncButtonComponent: components_async_button,
    pipelinesActionsComponent: components_pipelines_actions,
    pipelinesArtifactsComponent: components_pipelines_artifacts,
    commitComponent: commit["a" /* default */],
    pipelineStage: stage["a" /* default */],
    pipelineUrl: components_pipeline_url,
    ciBadge: ci_badge_link["a" /* default */],
    pipelinesTimeago: components_time_ago
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * This field needs a lot of verification, because of different possible cases:
     *
     * 1. person who is an author of a commit might be a GitLab user
     * 2. if person who is an author of a commit is a GitLab user he/she can have a GitLab avatar
     * 3. If GitLab user does not have avatar he/she might have a Gravatar
     * 4. If committer is not a GitLab User he/she can have a Gravatar
     * 5. We do not have consistent API object in this case
     * 6. We should improve API and the code
     *
     * @returns {Object|Undefined}
     */
    commitAuthor: function commitAuthor() {
      var commitAuthorInformation = void 0;

      if (!this.pipeline || !this.pipeline.commit) {
        return null;
      }

      // 1. person who is an author of a commit might be a GitLab user
      if (this.pipeline.commit.author) {
        // 2. if person who is an author of a commit is a GitLab user
        // he/she can have a GitLab avatar
        if (this.pipeline.commit.author.avatar_url) {
          commitAuthorInformation = this.pipeline.commit.author;

          // 3. If GitLab user does not have avatar he/she might have a Gravatar
        } else if (this.pipeline.commit.author_gravatar_url) {
          commitAuthorInformation = Object.assign({}, this.pipeline.commit.author, {
            avatar_url: this.pipeline.commit.author_gravatar_url
          });
        }
        // 4. If committer is not a GitLab User he/she can have a Gravatar
      } else {
        commitAuthorInformation = {
          avatar_url: this.pipeline.commit.author_gravatar_url,
          path: 'mailto:' + this.pipeline.commit.author_email,
          username: this.pipeline.commit.author_name
        };
      }

      return commitAuthorInformation;
    },


    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTag: function commitTag() {
      if (this.pipeline.ref && this.pipeline.ref.tag) {
        return this.pipeline.ref.tag;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit ref.
     * Needed to render the commit component column.
     *
     * Matches `path` prop sent in the API to `ref_url` prop needed
     * in the commit component.
     *
     * @returns {Object|Undefined}
     */
    commitRef: function commitRef() {
      var _this = this;

      if (this.pipeline.ref) {
        return Object.keys(this.pipeline.ref).reduce(function (accumulator, prop) {
          if (prop === 'path') {
            accumulator.ref_url = _this.pipeline.ref[prop];
          } else {
            accumulator[prop] = _this.pipeline.ref[prop];
          }
          return accumulator;
        }, {});
      }

      return undefined;
    },


    /**
     * If provided, returns the commit url.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitUrl: function commitUrl() {
      if (this.pipeline.commit && this.pipeline.commit.commit_path) {
        return this.pipeline.commit.commit_path;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit short sha.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitShortSha: function commitShortSha() {
      if (this.pipeline.commit && this.pipeline.commit.short_id) {
        return this.pipeline.commit.short_id;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit title.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTitle: function commitTitle() {
      if (this.pipeline.commit && this.pipeline.commit.title) {
        return this.pipeline.commit.title;
      }
      return undefined;
    },


    /**
     * Timeago components expects a number
     *
     * @return {type}  description
     */
    pipelineDuration: function pipelineDuration() {
      if (this.pipeline.details && this.pipeline.details.duration) {
        return this.pipeline.details.duration;
      }

      return 0;
    },


    /**
     * Timeago component expects a String.
     *
     * @return {String}
     */
    pipelineFinishedAt: function pipelineFinishedAt() {
      if (this.pipeline.details && this.pipeline.details.finished_at) {
        return this.pipeline.details.finished_at;
      }

      return '';
    },
    pipelineStatus: function pipelineStatus() {
      if (this.pipeline.details && this.pipeline.details.status) {
        return this.pipeline.details.status;
      }
      return {};
    },
    displayPipelineActions: function displayPipelineActions() {
      return this.pipeline.flags.retryable || this.pipeline.flags.cancelable || this.pipeline.details.manual_actions.length || this.pipeline.details.artifacts.length;
    },
    isChildView: function isChildView() {
      return this.viewType === 'child';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c853a7e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
var pipelines_table_row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commit gl-responsive-table-row"},[_c('div',{staticClass:"table-section section-10 commit-link"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Status\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('ci-badge',{attrs:{"status":_vm.pipelineStatus,"show-text":!_vm.isChildView}})],1)]),_vm._v(" "),_c('pipeline-url',{attrs:{"pipeline":_vm.pipeline,"auto-devops-help-path":_vm.autoDevopsHelpPath}}),_vm._v(" "),_c('div',{staticClass:"table-section section-20"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Commit\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('commit-component',{attrs:{"tag":_vm.commitTag,"commit-ref":_vm.commitRef,"commit-url":_vm.commitUrl,"short-sha":_vm.commitShortSha,"title":_vm.commitTitle,"author":_vm.commitAuthor,"show-branch":!_vm.isChildView}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-section section-wrap section-20 stage-cell"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Stages\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.pipeline.details.stages.length > 0)?_vm._l((_vm.pipeline.details.stages),function(stage,index){return _c('div',{key:index,staticClass:"stage-container dropdown js-mini-pipeline-graph"},[_c('pipeline-stage',{attrs:{"stage":stage,"update-dropdown":_vm.updateGraphDropdown}})],1)}):_vm._e()],2)]),_vm._v(" "),_c('pipelines-timeago',{attrs:{"duration":_vm.pipelineDuration,"finished-time":_vm.pipelineFinishedAt}}),_vm._v(" "),(_vm.displayPipelineActions)?_c('div',{staticClass:"table-section section-20 table-button-footer pipeline-actions"},[_c('div',{staticClass:"btn-group table-action-buttons"},[(_vm.pipeline.details.manual_actions.length)?_c('pipelines-actions-component',{attrs:{"actions":_vm.pipeline.details.manual_actions}}):_vm._e(),_vm._v(" "),(_vm.pipeline.details.artifacts.length)?_c('pipelines-artifacts-component',{staticClass:"hidden-xs hidden-sm",attrs:{"artifacts":_vm.pipeline.details.artifacts}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.retryable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.retry_path,"css-class":"js-pipelines-retry-button btn-default btn-retry","title":"Retry","icon":"repeat","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"retry"}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.cancelable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.cancel_path,"css-class":"js-pipelines-cancel-button btn-remove","title":"Stop","icon":"close","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"stop"}}):_vm._e()],1)]):_vm._e()],1)}
var pipelines_table_row_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_table_row.vue
/* script */


/* template */

/* template functional */
var pipelines_table_row___vue_template_functional__ = false
/* styles */
var pipelines_table_row___vue_styles__ = null
/* scopeId */
var pipelines_table_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table_row___vue_module_identifier__ = null

var pipelines_table_row_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table_row,
  pipelines_table_row_render,
  pipelines_table_row_staticRenderFns,
  pipelines_table_row___vue_template_functional__,
  pipelines_table_row___vue_styles__,
  pipelines_table_row___vue_scopeId__,
  pipelines_table_row___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table_row = (pipelines_table_row_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue






/**
 * Pipelines Table Component.
 *
 * Given an array of objects, renders a table.
 */
/* harmony default export */ var pipelines_table = ({
  components: {
    pipelinesTableRowComponent: components_pipelines_table_row,
    modal: modal["a" /* default */]
  },
  props: {
    pipelines: {
      type: Array,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      pipelineId: '',
      endpoint: '',
      type: ''
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Stop pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Retry pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false);
    },
    modalText: function modalText() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to stop pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to retry pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false);
    },
    primaryButtonLabel: function primaryButtonLabel() {
      return this.type === 'stop' ? Object(locale["e" /* s__ */])('Pipeline|Stop pipeline') : Object(locale["e" /* s__ */])('Pipeline|Retry pipeline');
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('openConfirmationModal', this.setModalData);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('openConfirmationModal', this.setModalData);
  },

  methods: {
    setModalData: function setModalData(data) {
      this.pipelineId = data.pipelineId;
      this.endpoint = data.endpoint;
      this.type = data.type;
    },
    onSubmit: function onSubmit() {
      event_hub["a" /* default */].$emit('postAction', this.endpoint);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b82e002","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
var pipelines_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-table"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.pipelines),function(model){return _c('pipelines-table-row-component',{key:model.id,attrs:{"pipeline":model,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})}),_vm._v(" "),_c('modal',{attrs:{"id":"confirmation-modal","title":_vm.modalTitle,"text":_vm.modalText,"kind":"danger","primary-button-label":_vm.primaryButtonLabel},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})],2)}
var pipelines_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-responsive-table-row table-row-header",attrs:{"role":"row"}},[_c('div',{staticClass:"table-section section-10 js-pipeline-status pipeline-status",attrs:{"role":"rowheader"}},[_vm._v("\n      状态\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-15 js-pipeline-info pipeline-info",attrs:{"role":"rowheader"}},[_vm._v("\n      流水线\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-commit pipeline-commit",attrs:{"role":"rowheader"}},[_vm._v("\n      提交\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-stages pipeline-stages",attrs:{"role":"rowheader"}},[_vm._v("\n      步骤\n    ")])])}]

// CONCATENATED MODULE: ./pipelines/components/pipelines_table.vue
/* script */


/* template */

/* template functional */
var pipelines_table___vue_template_functional__ = false
/* styles */
var pipelines_table___vue_styles__ = null
/* scopeId */
var pipelines_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table___vue_module_identifier__ = null

var pipelines_table_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  pipelines_table_render,
  pipelines_table_staticRenderFns,
  pipelines_table___vue_template_functional__,
  pipelines_table___vue_styles__,
  pipelines_table___vue_scopeId__,
  pipelines_table___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table = (pipelines_table_Component.exports);

// CONCATENATED MODULE: ./pipelines/mixins/pipelines.js










/* harmony default export */ var pipelines = __webpack_exports__["a"] = ({
  components: {
    PipelinesTableComponent: components_pipelines_table,
    SvgBlankState: components_blank_state,
    EmptyState: components_empty_state,
    LoadingIcon: loading_icon["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      hasError: false,
      isMakingRequest: false,
      updateGraphDropdown: false,
      hasMadeRequest: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.poll = new poll["a" /* default */]({
      resource: this.service,
      method: 'getPipelines',
      data: this.requestData ? this.requestData : undefined,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback,
      notificationCallback: this.setIsMakingRequest
    });

    if (!visibilityjs_default.a.hidden()) {
      this.isLoading = true;
      this.poll.makeRequest();
    } else {
      // If tab is not visible we need to make the first request so we don't show the empty
      // state without knowing if there are any pipelines
      this.fetchPipelines();
    }

    visibilityjs_default.a.change(function () {
      if (!visibilityjs_default.a.hidden()) {
        _this.poll.restart();
      } else {
        _this.poll.stop();
      }
    });

    event_hub["a" /* default */].$on('refreshPipelines', this.fetchPipelines);
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('refreshPipelines');
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  destroyed: function destroyed() {
    this.poll.stop();
  },

  methods: {
    fetchPipelines: function fetchPipelines() {
      var _this2 = this;

      if (!this.isMakingRequest) {
        this.isLoading = true;

        this.service.getPipelines(this.requestData).then(function (response) {
          return _this2.successCallback(response);
        }).catch(function () {
          return _this2.errorCallback();
        });
      }
    },
    setCommonData: function setCommonData(pipelines) {
      this.store.storePipelines(pipelines);
      this.isLoading = false;
      this.updateGraphDropdown = true;
      this.hasMadeRequest = true;
    },
    errorCallback: function errorCallback() {
      this.hasError = true;
      this.isLoading = false;
      this.updateGraphDropdown = false;
      this.hasMadeRequest = true;
    },
    setIsMakingRequest: function setIsMakingRequest(isMakingRequest) {
      this.isMakingRequest = isMakingRequest;

      if (isMakingRequest) {
        this.updateGraphDropdown = false;
      }
    },
    postAction: function postAction(endpoint) {
      this.service.postAction(endpoint).then(function () {
        return event_hub["a" /* default */].$emit('refreshPipelines');
      }).catch(function () {
        return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while making the request.'));
      });
    }
  }
});

/***/ }),

/***/ "./pipelines/services/pipelines_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var PipelinesService = function () {

  /**
  * Commits and merge request endpoints need to be requested with `.json`.
  *
  * The url provided to request the pipelines in the new merge request
  * page already has `.json`.
  *
  * @param  {String} root
  */
  function PipelinesService(root) {
    _classCallCheck(this, PipelinesService);

    var endpoint = void 0;

    if (root.indexOf('.json') === -1) {
      endpoint = root + '.json';
    } else {
      endpoint = root;
    }

    this.pipelines = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(endpoint);
  }

  _createClass(PipelinesService, [{
    key: 'getPipelines',
    value: function getPipelines() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = data.scope,
          page = data.page;

      return this.pipelines.get({ scope: scope, page: page });
    }

    /**
     * Post request for all pipelines actions.
     *
     * @param  {String} endpoint
     * @return {Promise}
     */

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint + '.json');
    }
  }]);

  return PipelinesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesService);

/***/ }),

/***/ "./pipelines/stores/pipelines_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PipelinesStore = function () {
  function PipelinesStore() {
    _classCallCheck(this, PipelinesStore);

    this.state = {};

    this.state.pipelines = [];
    this.state.count = {};
    this.state.pageInfo = {};
  }

  _createClass(PipelinesStore, [{
    key: 'storePipelines',
    value: function storePipelines() {
      var pipelines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.pipelines = pipelines;
    }
  }, {
    key: 'storeCount',
    value: function storeCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.count = count;
    }
  }, {
    key: 'storePagination',
    value: function storePagination() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["x" /* normalizeHeaders */])(pagination);
        paginationInfo = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["z" /* parseIntPagination */])(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }]);

  return PipelinesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesStore);

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue



/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ var ci_badge_link = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;
      return className ? 'ci-status ci-' + className : 'ci-status';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_badge_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_badge_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_badge_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36896c14","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/commit.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_commit.svg
var _icon_commit = __webpack_require__("../../views/shared/icons/_icon_commit.svg");
var _icon_commit_default = /*#__PURE__*/__webpack_require__.n(_icon_commit);

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/commit.vue






/* harmony default export */ var commit = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    userAvatarLink: user_avatar_link["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    /**
     * Indicates the existance of a tag.
     * Used to render the correct icon, if true will render `fa-tag` icon,
     * if false will render a svg sprite fork icon
     */
    tag: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If provided is used to render the branch name and url.
     * Should contain the following properties:
     * name
     * ref_url
     */
    commitRef: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    /**
     * Used to link to the commit sha.
     */
    commitUrl: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Used to show the commit short sha that links to the commit url.
     */
    shortSha: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided shows the commit tile.
     */
    title: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided renders information about the author of the commit.
     * When provided should include:
     * `avatar_url` to render the avatar icon
     * `web_url` to link to user profile
     * `username` to render alt and title tags
     */
    author: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    showBranch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    /**
     * Used to verify if all the properties needed to render the commit
     * ref section were provided.
     *
     * @returns {Boolean}
     */
    hasCommitRef: function hasCommitRef() {
      return this.commitRef && this.commitRef.name && this.commitRef.ref_url;
    },

    /**
     * Used to verify if all the properties needed to render the commit
     * author section were provided.
     *
     * @returns {Boolean}
     */
    hasAuthor: function hasAuthor() {
      return this.author && this.author.avatar_url && this.author.path && this.author.username;
    },

    /**
     * If information about the author is provided will return a string
     * to be rendered as the alt attribute of the img tag.
     *
     * @returns {String}
     */
    userImageAltDescription: function userImageAltDescription() {
      return this.author && this.author.username ? this.author.username + '\'s avatar' : null;
    }
  },
  created: function created() {
    this.commitIconSvg = _icon_commit_default.a;
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03412931","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branch-commit"},[(_vm.hasCommitRef && _vm.showBranch)?[_c('div',{staticClass:"icon-container"},[(_vm.tag)?_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.tag)?_c('icon',{attrs:{"name":"fork"}}):_vm._e()],1),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ref-name",attrs:{"href":_vm.commitRef.ref_url,"data-container":"body","title":_vm.commitRef.name}},[_vm._v("\n      "+_vm._s(_vm.commitRef.name)+"\n    ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"commit-icon js-commit-icon",domProps:{"innerHTML":_vm._s(_vm.commitIconSvg)}}),_vm._v(" "),_c('a',{staticClass:"commit-sha",attrs:{"href":_vm.commitUrl}},[_vm._v("\n    "+_vm._s(_vm.shortSha)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"commit-title flex-truncate-parent"},[(_vm.title)?_c('span',{staticClass:"flex-truncate-child"},[(_vm.hasAuthor)?_c('user-avatar-link',{staticClass:"avatar-image-container",attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.userImageAltDescription,"tooltip-text":_vm.author.username}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"commit-row-message",attrs:{"href":_vm.commitUrl}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1):_c('span',[_vm._v("\n      Cant find HEAD commit for this branch\n    ")])])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/commit.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  commit,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_commit = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/modal.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/require-default-prop */
/* harmony default export */ var modal = ({
  name: 'Modal',

  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    modalDialogClass: {
      type: String,
      required: false,
      default: ''
    },
    closeKind: {
      type: String,
      required: false,
      default: 'default'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    },
    btnCancelKindClass: function btnCancelKindClass() {
      return _defineProperty({}, 'btn-' + this.closeKind, true);
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e18618c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal",class:_vm.id ? '' : 'show',attrs:{"id":_vm.id,"role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalDialogClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title pull-left"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"close pull-right",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_c('p',[_vm._v(_vm._s(_vm.text))])],{text:_vm.text})],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",class:_vm.btnCancelKindClass,attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.closeButtonLabel)+"\n          ")]),_vm._v(" "),(_vm.secondaryButtonLabel)?_vm._t("secondary-button",[(_vm.secondaryButtonLabel)?_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              "+_vm._s(_vm.secondaryButtonLabel)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.primaryButtonLabel)?_c('button',{staticClass:"btn js-primary-button",class:_vm.btnKindClass,attrs:{"type":"button","disabled":_vm.submitDisabled,"data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.primaryButtonLabel)+"\n          ")]):_vm._e()],2):_vm._e()])])]),_vm._v(" "),(!_vm.id)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue


/* This is a re-usable vue component for rendering a user avatar wrapped in
  a clickable link (likely to the user's profile). The link, image, and
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-link
    :link-href="userProfileUrl"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :img-size="20"
    :tooltip-text="tooltipText"
    :tooltip-placement="top"
    :username="username"
  />

*/




/* harmony default export */ var user_avatar_link = ({
  name: 'UserAvatarLink',
  components: {
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    linkHref: {
      type: String,
      required: false,
      default: ''
    },
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: ''
    },
    imgCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgSize: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    username: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    shouldShowUsername: function shouldShowUsername() {
      return this.username.length > 0;
    },
    avatarTooltipText: function avatarTooltipText() {
      return this.shouldShowUsername ? '' : this.tooltipText;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd80867","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-avatar-link",attrs:{"href":_vm.linkHref}},[_c('user-avatar-image',{attrs:{"img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"css-classes":_vm.imgCssClasses,"size":_vm.imgSize,"tooltip-text":_vm.avatarTooltipText,"tooltip-placement":_vm.tooltipPlacement}}),(_vm.shouldShowUsername)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.tooltipText,"tooltip-placement":_vm.tooltipPlacement}},[_vm._v(_vm._s(_vm.username))]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Helper to user bootstrap popover in vue.js.
 * Follow docs for html attributes: https://getbootstrap.com/docs/3.3/javascript/#static-popover
 *
 * @example
 * import popover from 'vue_shared/directives/popover.js';
 * {
 *   directives: [popover]
 * }
 * <a v-popover="{options}">popover</a>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    $(el).popover(binding.value);
  },
  unbind: function unbind(el) {
    $(el).popover('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["d" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["a" /* formatDate */])(time);
    }
  }
});

/***/ })

},["./pages/projects/commit/pipelines/index.js"]);


// WEBPACK FOOTER //
// pages.projects.commit.pipelines.64f238a775121d5e17a8.bundle.js